import { gql } from '@apollo/client';

export const METADATA_QUERY = gql`
  query metadata {
    metadata {
      id
      code
      name
      dataType
      entityType
    }
  }
`;
